import Vue from 'vue'
import './plugins/axios'
import App from './App.vue'
import router from './router'
import store from './store'
import VueGtag from 'vue-gtag'

import LogoLink from '@/components/common/LogoLink'

import vh from '@sparing-software/100vh'

Vue.component('LogoLink', LogoLink)

vh.init()

Vue.config.productionTip = false

if (process.env.VUE_APP_IS_PRODUCTION === 'true') {
  Vue.use(VueGtag, {
    config: { id: 'UA-164763750-1' }
  })
}

new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
